export default __webpack_public_path__ + "static/media/gallery_04.d41c0fbe.jpg";